import { Component, OnDestroy, OnInit } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { NavController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { IntroEnvironmentGateService } from 'src/app/services/intro-environment-gate/intro-environment-gate.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'pn-intro-component',
  templateUrl: './pn-intro-component.component.html',
  styleUrls: ['./pn-intro-component.component.scss'],
  standalone: false,
})
export class PnIntroComponent implements OnInit, OnDestroy {
  scanFriendAllowed: boolean = environment.scanFriendAllowed;
  enableRegistration: boolean = true;
  environmentReady = false;

  private environmentGateSub?: Subscription;

  constructor(
    private navCtrl: NavController,
    private _introEnvironmentGate: IntroEnvironmentGateService,
  ) {
    if (Capacitor.isNativePlatform()) {
      this.enableRegistration = environment.enableMobileRegistation;
    } else {
      this.enableRegistration = environment.enableWebRegistation;
    }
  }

  ngOnInit(): void {
    this.environmentGateSub = this._introEnvironmentGate.bind((ready) => {
      this.environmentReady = ready;
    });
  }

  ngOnDestroy(): void {
    this.environmentGateSub?.unsubscribe();
  }

  async getStarted(): Promise<void> {
    if (!this.environmentReady) {
      return;
    }
    await this.navCtrl.navigateForward('/client/patientnavigator/pn-register');
  }

  async login(): Promise<void> {
    if (!this.environmentReady) {
      return;
    }
    await this.navCtrl.navigateForward('/v2/account/login');
  }

  async vivaLite(): Promise<void> {
    if (!this.environmentReady) {
      return;
    }
    await this.navCtrl.navigateForward('/viva-lite/access-code');
  }
}
